import styled from "styled-components";

// cropperjs рисует в своей разметке — ограничиваем её шириной тела диалога.
export const CropperBox = styled.div`
    max-width: 100%;
    overflow: hidden;
`;

export const RotateRow = styled.div`
    display: flex;
    justify-content: center;
    gap: 8px;
`;

export const Loading = styled.div`
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
